import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GET_TRANSACTIONAL_DATA_REPORT, UPLOAD_TRANSACTIONAL_DATA_REPORT } from "../../../Types";

export const addTransactionalSheet = (formValues) => async (dispatch) => {
  dispatch(showLoading());
  const formData = new FormData();
  formData.append("DistributorId", formValues.distributorId);
  formData.append("DistCenterId", formValues.DistCenterId);
  formData.append("bankId", formValues.bankId);
  formData.append("DataFile", formValues.DataFile);
  if (formValues.assignedDistCenters) {
    formData.append("assignedDistCenters", formValues.assignedDistCenters);
  }

  const config = {
    headers: { "content-type": "multipart/form-data" },
  };
  await axios
    .post("api/ShopTransactionalData/UploadTransactionalDataSheet", formData, config)
    .then(({ data }) => {
      if (data.isSuccess) {
        dispatch({
          type: UPLOAD_TRANSACTIONAL_DATA_REPORT,
          payload: data.response,
        });
        dispatch(hideLoading());
        toast.success(data.message);
      } else {
        toast.info(data.message);
      }
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const getTransactionalData = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/ShopTransactionalData/GetTransactionalDataList`, postedData)
    .then(({ data }) => {
      //debugger;
      // if (data && data.length > 0)
      dispatch({
        type: GET_TRANSACTIONAL_DATA_REPORT,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const downloadJob = (filterModel) => async (dispatch) => {
  dispatch(showLoading());

  try {
    const { data } = await axios.post(
      `api/ShopTransactionalData/ExportTransactionalDataReport`,
      filterModel
    );

    if (!data?.isSuccess || !data?.response?.length) {
      toast.error("No data available to export.");
      dispatch(hideLoading());
      return;
    }

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const outputFilename = `TransactionalData_Export_${Date.now()}`;

    const jsonData = data.response;

    // ✅ Explicit column mapping (same as backend export model)
    const formattedData = jsonData.map((item) => ({
      DistributorId: item.distributorId,
      DistributionCenterId: item.distCenterId,
      BankId: item.distBankId,
      VizId: item.vizId,
      SequenceNo: item.sequanceNo,
      CustomerCNIC: item.customerCNIC,
      ShopId: item.shopId,
      ShopAddress: item.shopAddress,
      BusinessType: item.businessType,
      MobileNo: item.mobileNo,
      EmailAddress: item.emailAddress,
      SellerOrDistributorName: item.sellerOrDistributorName,
      UserName: item.userName,
      StoreName: item.storeName,
      ShopTimings: item.shopTimings,
      StoreType: item.storeType,
      Area: item.area,
      City: item.city,
      District: item.district,
      UserActivatedOnApp: item.userActivatedOnApp,
      IsSmartphoneUser: item.isSmartphoneUser,
      ConventionalRelationshipSince: item.conventionalRelationshipSince,
      RelationshipOnAppSince: item.relationshipOnAppSince,
      LastLoginDateTime: item.lastLoginDateTime,
      MoMNoOfLoginsLast6Months: item.moMNoOfLoginsLast6Months,

      OrderId: item.orderId,
      OrderBookedThrough: item.orderBookedThrough,
      OrderPlacedOnApp: item.orderPlacedOnApp,
      OrderDescription: item.orderDescription,
      OrderDate: item.orderDate,
      OrderValue: item.orderValue,
      OrderStatus: item.orderStatus,
      ReturnValue: item.returnValue,
      DeliveryDate: item.deliveryDate,
      PaymentTerms: item.paymentTerms,
      OrderFinancedBy: item.orderFinancedBy,
      CreditType: item.creditType,
      PaymentPlan: item.paymentPlan,
      TotalInstallments: item.totalInstallmentsInPaymentPlan,
      TotalFinancingAmountDue: item.totalFinancingAmountDue,
      PaymentDueDate: item.paymentDueDate,
      PaymentReceiptDate: item.paymentReceiptDate,
      CreditOrMarkupRatePercentage: item.creditOrMarkupRatePercentage,
      InstallmentAmount: item.installmentAmountIfOnCredit,
      PaymentStatus: item.paymentStatus,
      AmountRecovered: item.amountRecovered,
      OutstandingAmount: item.outstandingAmount,
      OverdueAmount: item.overdueAmount,
      NoOfOverdueInstallments: item.noOfOverdueInstallments,
      FinalInstallmentDate: item.finalInstallmentDate,
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData);

    const headerMap = {
      DistributorId: "Distributor",
      DistributionCenterId: "Distribution Center",
      BankId: "Bank",
      VizId: "VIZ ID",
      SequenceNo: "Sequence No",
      CustomerCNIC: "Customer CNIC",
      ShopId: "Shop ID",
      ShopAddress: "Shop Address",
      BusinessType: "Business Type",
      MobileNo: "Mobile No",
      EmailAddress: "Email Address",
      SellerOrDistributorName: "Seller/Distributor Name",
      UserName: "User Name",
      StoreName: "Store Name",
      ShopTimings: "Shop Timings",
      StoreType: "Store Type",
      Area: "Area",
      City: "City",
      District: "District",
      UserActivatedOnApp: "User Activated On App",
      IsSmartphoneUser: "Is Smartphone User",
      ConventionalRelationshipSince: "Conventional Relationship Since",
      RelationshipOnAppSince: "Relationship On App Since",
      LastLoginDateTime: "Last Login DateTime",
      MoMNoOfLoginsLast6Months: "MoM No Of Logins (Last 6 Months)",

      OrderId: "Order ID",
      OrderBookedThrough: "Order Booked Through",
      OrderPlacedOnApp: "Order Placed On App",
      OrderDescription: "Order Description",
      OrderDate: "Order Date",
      OrderValue: "Order Value",
      OrderStatus: "Order Status",
      ReturnValue: "Return Value",
      DeliveryDate: "Delivery Date",
      PaymentTerms: "Payment Terms",
      OrderFinancedBy: "Order Financed By",
      CreditType: "Credit Type",
      PaymentPlan: "Payment Plan",
      TotalInstallments: "Total Installments",
      TotalFinancingAmountDue: "Total Financing Amount Due",
      PaymentDueDate: "Payment Due Date",
      PaymentReceiptDate: "Payment Receipt Date",
      CreditOrMarkupRatePercentage: "Credit/Markup Rate %",
      InstallmentAmount: "Installment Amount",
      PaymentStatus: "Payment Status",
      AmountRecovered: "Amount Recovered",
      OutstandingAmount: "Outstanding Amount",
      OverdueAmount: "Overdue Amount",
      NoOfOverdueInstallments: "No Of Overdue Installments",
      FinalInstallmentDate: "Final Installment Date",
    };

    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const address = XLSX.utils.encode_col(C) + "1";
      if (!ws[address]) continue;
      const originalHeader = ws[address].v;
      ws[address].v = headerMap[originalHeader] || originalHeader;
    }

    const wb = {
      Sheets: { data: ws },
      SheetNames: ["data"],
    };

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], { type: fileType });
    fileSaver.saveAs(fileData, outputFilename + fileExtension);

    dispatch(hideLoading());
  } catch (error) {
    dispatch(hideLoading());

    if (error.response?.status === 401) {
      logout();
      history.push("/login");
      return;
    }

    toast.error(
      error.response?.data?.message ||
        error.response?.data?.Message ||
        "Error while processing the request"
    );
  }
};
